/**
 * GlamoryZone filter UX enhancements
 * - In-facet live search for long option lists
 * - Sticky active-filter chips bar polish hooks
 * - Collection convenience search bar (fallback if liquid missing)
 * Does not interfere with Shopify facets.js form submissions.
 */
(function () {
  'use strict';

  var MIN_OPTIONS = 6;
  var SEARCH_PLACEHOLDER = 'Search brands, sizes…';
  var COLLECTION_SEARCH_PLACEHOLDER = 'Search by brand, size, color…';
  var QUICK_HANDLES = [
    { handle: 'women', label: 'Women' },
    { handle: 'men', label: 'Men' },
    { handle: 'sale', label: 'Sale' }
  ];

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isCollectionTemplate() {
    var main = qs(document, '#MainContent');
    if (main && main.getAttribute('data-template')) {
      return main.getAttribute('data-template').indexOf('collection') === 0;
    }
    return /^\/collections\//.test(location.pathname);
  }

  function optionLabel(item) {
    var input = qs(item, 'input[data-label], input[aria-label], input');
    if (input) {
      return (
        input.getAttribute('data-label') ||
        input.getAttribute('aria-label') ||
        ''
      ).trim();
    }
    var text = qs(item, '.checkbox__label-text, .facets__pill-label, .facets__swatch-label, .facets__image-label, label');
    return (text ? text.textContent : item.textContent || '').trim();
  }

  function ensureFacetSearch(panel) {
    if (!panel || panel.dataset.gzFacetSearch === '1') return;
    var list = qs(panel, 'ul.facets__inputs-list');
    if (!list) return;
    var items = qsa(list, ':scope > li.facets__inputs-list-item, :scope > li');
    if (items.length < MIN_OPTIONS) return;

    // Skip pure swatch grids without text labels (still allow if labels exist)
    var labeled = items.filter(function (li) {
      return optionLabel(li).length > 0;
    });
    if (labeled.length < MIN_OPTIONS) return;

    var inputsWrap = qs(panel, '.facets__inputs-wrapper') || list.parentElement;
    if (!inputsWrap) return;

    var wrap = document.createElement('div');
    wrap.className = 'gz-facet-search';
    wrap.innerHTML =
      '<label class="gz-facet-search__label visually-hidden" for="">Search filter options</label>' +
      '<input type="search" class="gz-facet-search__input" placeholder="' +
      SEARCH_PLACEHOLDER +
      '" autocomplete="off" enterkeyhint="search" />' +
      '<p class="gz-facet-search__empty" hidden>No matches</p>';

    var input = qs(wrap, '.gz-facet-search__input');
    var empty = qs(wrap, '.gz-facet-search__empty');
    var label = qs(wrap, '.gz-facet-search__label');
    var id = 'gz-facet-search-' + Math.random().toString(36).slice(2, 9);
    input.id = id;
    label.setAttribute('for', id);

    // Insert before the list / show-more content
    inputsWrap.insertBefore(wrap, inputsWrap.firstChild);

    function filterOptions() {
      var q = (input.value || '').trim().toLowerCase();
      var visible = 0;
      items.forEach(function (li) {
        var labelText = optionLabel(li).toLowerCase();
        var match = !q || labelText.indexOf(q) !== -1;
        // Keep theme's own hide classes intact for show-more, but override via our attr
        if (match) {
          li.removeAttribute('data-gz-hide');
          visible++;
        } else {
          li.setAttribute('data-gz-hide', '1');
        }
      });
      if (empty) empty.hidden = !(q && visible === 0);

      // When searching, expand show-more so matches aren't truncated
      if (q) {
        var showMore = panel.closest('show-more-component') || qs(panel, 'show-more-component') || panel.querySelector('show-more-component');
        // panel is floating-panel; show-more wraps inputs
        var sm = panel.querySelector('show-more-component');
        if (sm && sm.getAttribute('data-expanded') !== 'true') {
          sm.setAttribute('data-expanded', 'true');
          sm.classList.add('gz-facet-search-expanded');
        }
        // Also unhide theme mobile:hidden / show-more hidden items while searching
        items.forEach(function (li) {
          if (!li.hasAttribute('data-gz-hide')) {
            li.classList.add('gz-facet-search-force-show');
          } else {
            li.classList.remove('gz-facet-search-force-show');
          }
        });
      } else {
        items.forEach(function (li) {
          li.classList.remove('gz-facet-search-force-show');
        });
        var sm2 = panel.querySelector('show-more-component');
        if (sm2 && sm2.classList.contains('gz-facet-search-expanded')) {
          sm2.setAttribute('data-expanded', 'false');
          sm2.classList.remove('gz-facet-search-expanded');
        }
      }
    }

    input.addEventListener('input', filterOptions);
    input.addEventListener('keydown', function (e) {
      // Never submit parent facet forms on Enter
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    panel.dataset.gzFacetSearch = '1';
  }

  function enhanceAllFacets(root) {
    var scope = root || document;
    qsa(scope, '.facets__panel-content, floating-panel-component.facets__inputs').forEach(ensureFacetSearch);
    // Also target accordion panels that contain lists
    qsa(scope, 'accordion-custom.facets__item .facets__inputs').forEach(ensureFacetSearch);
  }

  function stickyChips() {
    var bars = qsa(document, '.facets-remove, .facets-remove--mobile-and-vertical');
    bars.forEach(function (bar) {
      if (bar.dataset.gzSticky === '1') return;
      bar.classList.add('gz-active-filters');
      if (bar.children.length > 0) {
        bar.classList.add('gz-active-filters--has-chips');
      }
      bar.dataset.gzSticky = '1';
    });
  }

  function ensureCollectionSearchBar() {
    if (!isCollectionTemplate()) return;
    if (qs(document, '.gz-collection-search')) return;

    var anchor =
      qs(document, 'results-list.product-grid-container') ||
      qs(document, '.collection-wrapper') ||
      qs(document, '#MainContent');
    if (!anchor) return;

    var bar = document.createElement('div');
    bar.className = 'gz-collection-search page-width';
    bar.setAttribute('data-gz-injected', '1');

    var chipsHtml = QUICK_HANDLES.map(function (c) {
      return (
        '<a class="gz-collection-search__chip" href="/collections/' +
        c.handle +
        '">' +
        c.label +
        '</a>'
      );
    }).join('');

    bar.innerHTML =
      '<form class="gz-collection-search__form" action="/search" method="get" role="search">' +
      '<input type="hidden" name="type" value="product" />' +
      '<label class="visually-hidden" for="gz-collection-q">Search products</label>' +
      '<input id="gz-collection-q" class="gz-collection-search__input" type="search" name="q" ' +
      'placeholder="' +
      COLLECTION_SEARCH_PLACEHOLDER +
      '" autocomplete="off" />' +
      '<button type="submit" class="gz-collection-search__submit">Search</button>' +
      '</form>' +
      '<div class="gz-collection-search__chips" aria-label="Quick collections">' +
      chipsHtml +
      '<a class="gz-collection-search__chip gz-collection-search__chip--hint" href="/search?type=product&amp;q=">Full filters on Search →</a>' +
      '</div>';

    // Prefer inserting before results-list
    if (anchor.tagName && anchor.tagName.toLowerCase() === 'results-list') {
      anchor.parentNode.insertBefore(bar, anchor);
    } else if (qs(document, '.collection-wrapper')) {
      var wrap = qs(document, '.collection-wrapper');
      wrap.parentNode.insertBefore(bar, wrap);
    } else {
      anchor.insertBefore(bar, anchor.firstChild);
    }
  }

  function init() {
    enhanceAllFacets(document);
    stickyChips();
    ensureCollectionSearchBar();
  }

  // Shopify facets re-render via morph / section rendering — re-apply
  function observe() {
    var target = qs(document, '#MainContent') || document.body;
    if (!target || typeof MutationObserver === 'undefined') return;
    var timer = null;
    var obs = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        enhanceAllFacets(document);
        stickyChips();
        ensureCollectionSearchBar();
      }, 80);
    });
    obs.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observe();
    });
  } else {
    init();
    observe();
  }

  // Also listen for common Shopify facet events if present
  document.addEventListener('facet:update', function () {
    setTimeout(init, 50);
  });
})();
